
import "@/styles/pages/multiMonitorCapture/index.scss";
import "@/styles/components/com-live-chat.css";
import registerOurDomain from "@/components/ourDomain";
import registerCnLiveChat from "@/components/cn-live-chat";
import registerComLiveChat from "@/components/com-live-chat";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // 入口文件

new Vue({
  created($, apower, LazyLoad) {
    registerOurDomain($, apower);
    registerCnLiveChat($, apower);
    registerComLiveChat($, apower);
    const advanceConfig = {
      duration: 8000,
      /** @private */
      _advanceIndex: 0,
      get advanceIndex() {
        return this._advanceIndex;
      },
      set advanceIndex(index) {
        this._advanceIndex = index;
        this.updateIndex(this._advanceIndex);
      },

      timer: null,
      startInterval() {
        /** @param ev {PointerEvent} */
        const handleAdvance = (ev) => {
          this.stopInterval();
          const itemClass = "advance-item";
          const index = getIndex(ev.target);
          this.updateIndex(index);
          this.startInterval();

          /** @param target {HTMLElement}*/
          function getIndex(target) {
            if (target.classList.contains(itemClass)) {
              return Array.from(rightList.children).indexOf(target);
            } else {
              target = target.parentElement;
              return getIndex(target);
            }
          }
        };
        //advance区域8s切换
        const rightList = document.querySelector("#advance-right-list-id");
        const advanceItems = rightList.querySelectorAll(".advance-item ");
        advanceItems.forEach((item) => {
          item.onmouseenter = handleAdvance;
        });

        this.timer = setInterval(() => {
          if (advanceConfig.advanceIndex >= rightList.children.length - 1) {
            advanceConfig.advanceIndex = 0;
          } else {
            advanceConfig.advanceIndex++;
          }
        }, this.duration);
      },
      stopInterval() {
        clearInterval(this.timer);
      },
      updateIndex(selectIndex) {
        const leftImgList = document.querySelector("#advance-img-id");
        const rightList = document.querySelector("#advance-right-list-id");
        /** @template T {Element} */
        Array.from(leftImgList.children).forEach((item, index) => {
          item.classList.remove("active");
          if (selectIndex === index) {
            item.classList.add("active");
          }
        });
        Array.from(rightList.children).forEach((item, index) => {
          item.classList.remove("active");
          if (selectIndex === index) {
            item.classList.add("active");
          }
        });
      },
    };
    advanceConfig.startInterval();
  },
});

(function (doc, win, designWidth) {
  const html = doc.documentElement;

  function refreshRem() {
    const clientWidth = html.clientWidth;
    if (clientWidth >= designWidth) {
      html.style.fontSize = "100px";
    } else if (clientWidth < 769) {
      html.style.fontSize = 100 * (clientWidth / 414) + "px";
    } else {
      html.style.fontSize = 100 * (clientWidth / designWidth) + "px";
    }
  }

  refreshRem();

  // doc.addEventListener("DOMContentLoaded", refreshRem);
  win.addEventListener("resize", refreshRem);
})(document, window, 1920);

          })
        